import { useContext, useEffect, useState } from "react";
import "./AircraftFlightStatus.css";
import { getLastFlightInformation } from "../../services/AircraftConfigurationService";
import { AircraftDeliveryInfoContext } from "../../contexts/AircraftDeliveryInfoContext";

const AircraftFlightStatus = ({ aircraft, disabled, ribbon, open }) => {
  const [currentTime, setCurrentTime] = useState(() => {
    const now = new Date();
    const yyyy = now.getFullYear();
    const mm = String(now.getMonth() + 1).padStart(2, "0");
    const dd = String(now.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  });
  const { updateInformation } = useContext(AircraftDeliveryInfoContext);
  const [originInfo, setOriginInfo] = useState();
  const [destinationInfo, setDestinationInfo] = useState();
  const [flightInformation, setFlightInformation] = useState({
    totalFlightHours: 0,
    totalFlightMinutes: 0,
    totalFlightCycles: 0,
    totalBlockHours: 0,
    totalBlockMinutes: 0,
    totalBlockCycles: 0,
  });
  useEffect(() => {
    if (open) {
      getLastFlightInformation(aircraft.id)
        .then((response) => {
          if (response.data.responseCode === 200) {
            if (response.data.load != null) {
              let {
                totalFlightHours,
                totalFlightMinutes,
                totalFlightCycles,
                totalBlockHours,
                flightDate,
                destinationLocationCode,
                originLocationCode,
                totalBlockMinutes,
                totalBlockCycles,
              } = response.data.load;

              const normalizedFlightHours =
                totalFlightHours + Math.floor(totalFlightMinutes / 60);
              const residualFlightMinutes = totalFlightMinutes % 60;

              const normalizedBlockHours =
                totalBlockHours + Math.floor(totalBlockMinutes / 60);
              const residualBlockMinutes = totalBlockMinutes % 60;

              setOriginInfo(originLocationCode);
              setDestinationInfo(destinationLocationCode);
              setCurrentTime(flightDate.split("T")[0]);
              setFlightInformation({
                totalFlightHours: `${normalizedFlightHours}:${(residualFlightMinutes < 10 ? "0" + residualFlightMinutes : residualFlightMinutes)}`,
                totalBlockHours: `${normalizedBlockHours}:${(residualBlockMinutes < 10 ? "0" + residualBlockMinutes : residualFlightMinutes)}`,
                totalFlightCycles,
                totalBlockCycles,
              });
            }
          }
        })
        .catch((error) => {});
    }
  }, [open, aircraft, updateInformation]);

  return (
    <div className="flight-status-container">
      <div className="flight-status-container-header">
        <b>Flight Status</b>
        <div className="flight-status-container-header-info">
          <b>Overnight</b>
          <div className="flight-status-container-header-info-value">
            <div className="flight-status-container-header-info-value-icon">
              <div className="icon-moon"></div>
              <p>RON Hours</p>
            </div>
            <b>10:45</b>
          </div>
        </div>
        <div className="flight-status-container-airport-info">
          <div className="flight-status-container-airport-info-icon">
            <div className="icon-airport"></div>
            <p>RON Station</p>
          </div>
          <div className="flight-status-container-airport-info-text">
            <p>
              <b>{originInfo?.standardCode ?? "--"}</b> -{" "}
              {originInfo?.name ?? ""}.
            </p>
            <p>{originInfo?.municipality ?? "--"}</p>
          </div>
        </div>

        <div className="flight-status-container-airport-info">
          <div className="flight-status-container-airport-info-icon">
            <div className="icon-airport"></div>
            <p>Previous RON Station</p>
          </div>
          <div className="flight-status-container-airport-info-text">
            <p>
              <b>{destinationInfo?.standardCode ?? "--"}</b> -
              {destinationInfo?.name ?? ""}.
            </p>
            <p>{destinationInfo?.municipality ?? "--"}</p>
          </div>
        </div>
      </div>
      <div className="flight-status-container-body">
        <b>Last Flight Information</b>
      </div>
      <div className="flight-status-container-body-flight">
        <div className="flight-status-container-body-flight-info">
          <div className="icon-flight-info"></div>
          <p>Last Flight Date</p>
        </div>
        <div className="flight-status-container-body-flight-date">
          <b>{currentTime}</b>
          <div className="icon-date"></div>
        </div>
      </div>
      <div className="flight-status-container-body-flight-kpi">
        <div className="flight-status-container-body-flight-kpi-info">
          <div className="icon-flight-total icon"></div>
          <div className="flight-status-container-body-flight-kpi-info-text">
            <b>{flightInformation.totalFlightHours ?? "--"}</b>
            <p>Total Flight Hours</p>
          </div>
        </div>
        <div className="flight-status-container-body-flight-kpi-info">
          <div className="icon-flight-hours icon"></div>
          <div className="flight-status-container-body-flight-kpi-info-text">
            <b>{flightInformation.totalBlockHours ?? "--"}</b>
            <p>Total Block Hours</p>
          </div>
        </div>
        <div className="flight-status-container-body-flight-kpi-info">
          <div className="icon-flight-cycles icon"></div>
          <div className="flight-status-container-body-flight-kpi-info-text">
            <b>{flightInformation.totalFlightCycles ?? "--"}</b>
            <p>Total Flight Cycles</p>
          </div>
        </div>
        <div className="flight-status-container-body-flight-kpi-info">
          <div className="icon-total-breaks icon"></div>
          <div className="flight-status-container-body-flight-kpi-info-text">
            <b>{flightInformation.totalBlockCycles ?? "--"}</b>
            <p>Total Breaks Cycles</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AircraftFlightStatus;
